(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-video-overlay"] && !Shopify.designMode) return;
  try {
    
  $(function() {
   
    $('.popup-vimeo').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.accordion-header');
  const item = document.querySelector('.accordion-item');

  header.addEventListener('click', function () {
    const isOpen = item.classList.contains('open');

    // Toggle the accordion item
    if (!isOpen) {
      item.classList.add('open');
    } else {
      item.classList.remove('open');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
